import React from "react";

import LogoWhite from "../../assets/images/logo-white.png";

const Footer = () => {
    return (
        <footer className="pb-50  pt-70 pos-relative">
            <div className="pos-top triangle-bottom" />
            <div className="container-fluid">
                <a href="index.html">
                    <img src={LogoWhite} alt="Logo" />
                </a>

                <div className="pt-30">
                    <p className="underline-secondary">
                        <b>Address:</b>
                    </p>
                    <p>481 Creekside Lane Avila Beach, CA 93424 </p>
                </div>

                <div className="pt-30">
                    <p className="underline-secondary mb-10">
                        <b>Phone:</b>
                    </p>
                    <a href="tel:+53 345 7953 32453 ">+53 345 7953 32453 </a>
                </div>

                <div className="pt-30">
                    <p className="underline-secondary mb-10">
                        <b>Email:</b>
                    </p>
                    <a href="mailto:yourmail@gmail.com"> yourmail@gmail.com</a>
                </div>

                <ul className="icon mt-30">
                    <li>
                        <a href="#">
                            <i className="ion-social-pinterest" />
                        </a>
                    </li>
                    <li>
                        <a href="#">
                            <i className="ion-social-facebook" />
                        </a>
                    </li>
                    <li>
                        <a href="#">
                            <i className="ion-social-twitter" />
                        </a>
                    </li>
                    <li>
                        <a href="#">
                            <i className="ion-social-dribbble-outline" />
                        </a>
                    </li>
                    <li>
                        <a href="#">
                            <i className="ion-social-linkedin" />
                        </a>
                    </li>
                    <li>
                        <a href="#">
                            <i className="ion-social-vimeo" />
                        </a>
                    </li>
                </ul>

                <p>
                    Copyright &copy; 2019 All rights reserved | Made with{" "}
                    <i className="ion-heart" aria-hidden="true" /> by{" "}
                    <a href="https://colorlib.com" target="_blank">
                        Radivoje Dundjerovic
                    </a>
                </p>
            </div>
        </footer>
    );
};

export default Footer;
